import React from 'react';
import ModalVideo from 'react-modal-video';
import '../css/react-modal-video.min.css';

import backgroundImage from '../img/header2.png';
import crew from '../img/crew.png';
import johnMehak from '../img/johnMehak.png';

import mehak from '../img/team/1.jpg';
import rohan from '../img/team/2.jpg';
import john from '../img/team/3.jpg';

class VideoPopUp extends React.Component {
  constructor() {
    super();
    this.state = {
      showVideo: false,
    };
  }
  render() {
    return (
      <div className="block-image">
        <ModalVideo
          channel="youtube"
          isOpen={this.state.showVideo}
          videoId="eXbd5H-ea5Q"
          onClose={() => this.setState({ showVideo: false })}
        />
        <a href="#" onClick={() => this.setState({ showVideo: true })}>
          <img src={backgroundImage} className="img-center" />
        </a>
      </div>
    );
  }
}

const BrewCrew = () => (
  <div>
    <section className="background-image-holder">
      <div
        className="slice holder-item holder-item-light has-bg-cover bg-size-cover"
        style={{
          backgroundImage: `url(${johnMehak})`,
          backgroundPosition: 'left center',
        }}
      >
        <div className="mask bg-base-4 alpha-6" />
        <div className="container slice-lg slice--offset-top">
          <div className="row cols-xs-space align-items-center text-center text-md-left justify-content-center">
            <div className="col-lg-7">
              <div className="text-center mt-5">
                <h2 className="heading display-4 text-white mt-4 mb-0 heading-responsive strong-700">
                  <span className="font-weight-700">Meet the Brew Crew</span>
                </h2>
                <h2 className="text-white heading-3 text-lg mt-2">
                  <span className="font-weight-700">
                    Meet the world's first and #1 LinkedIn influencer team.
                  </span>
                </h2>
                <div className="row justify-content-center mt-5">
                  <div className="col-lg-8">
                    <div className="block block-image-holder z-depth-3">
                      <VideoPopUp />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="slice sct-color-1">
      <div className="container">
        <div className="section-title section-title--style-1 text-center mb-4">
          <h3 className="section-title-inner">
            <span>The world's #1 LinkedIn influencer team.</span>
          </h3>
          <span className="section-title-delimiter clearfix d-none" />
        </div>

        <span className="clearfix" />

        <span className="space-xs-xl" />

        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="block block-image-holder">
              <img
                src={crew}
                style={{ width: '600px' }}
                className="block-image"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="feature feature--boxed-border floating-content float--left sct-color-2">
              <h2 className="heading heading-3 strong-600">Who Are We?</h2>
              <span className="clearfix" />
              <p className="mt-3">
                We create thought leaders, and help them create their own
                conversation in tech. Our influencers work together to create
                content and leverage each other’s audience.
              </p>
            </div>
          </div>
        </div>

        <span className="space-xs-md" />

        <div className="row">
          <div className="col-lg-3 col-6">
            <div className="milestone-counter text-center">
              <div className="milestone-count milestone-count-xs c-gray-dark strong-600">
                90k
              </div>
              <h4 className="milestone-info strong-500 text-normal mt-3">
                Followers
              </h4>
            </div>
          </div>
          <div className="col-lg-3 col-6">
            <div className="milestone-counter text-center">
              <div className="milestone-count milestone-count-xs c-gray-dark strong-600">
                4M+
              </div>
              <h4 className="milestone-info strong-500 text-normal mt-3">
                Views Per Month
              </h4>
            </div>
          </div>
          <div className="col-lg-3 col-6">
            <div className="milestone-counter text-center">
              <div className="milestone-count milestone-count-xs c-gray-dark strong-600">
                3
              </div>
              <h4 className="milestone-info strong-500 text-normal mt-3">
                Influencers
              </h4>
            </div>
          </div>
          <div className="col-lg-3 col-6">
            <div className="milestone-counter text-center">
              <div className="milestone-count milestone-count-xs c-gray-dark strong-600">
                ∞
              </div>
              <h4 className="milestone-info strong-500 text-normal mt-3">
                Cups of Coffee
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="slice-sm sct-color-1">
      <div className="container">
        <div className="section-title section-title--style-1 text-center mb-4">
          <h3 className="section-title-inner">
            <span>Meet the Dream Team</span>
          </h3>
          <span className="section-title-delimiter clearfix d-none" />
        </div>

        <div className="row">
          <div className="col-lg-4 col-6">
            <div className="block block--style-3 block--style-3-v2">
              <div className="block-image">
                <img src={mehak} className="block-image" />
              </div>
              <div className="block-body py-3">
                <h3 className="heading heading-6 strong-600 mb-0">
                  Mehak Vohra
                </h3>
                <h4 className="heading heading-sm strong-300 mb-0">
                  Tech News and Gen Z
                </h4>
              </div>
              <div className="block-body border-top py-3">
                <p className="mb-0">
                  Mehak Vohra is the founder and CEO of Jamocha Media. She was
                  #4 on Forbes Top 10 Gen Z Marketers list of 2017. She creates
                  content around tech and startups primarily on YouTube,
                  LinkedIn, and Quora.
                </p>
              </div>
              <div className="block-footer border-top py-3">
                <ul className="social-media social-media--style-1-v4">
                  <li>
                    <a
                      href="https://www.facebook.com/watthemehak/"
                      className="facebook"
                      target="_blank"
                      title="Facebook"
                    >
                      <i className="fa fa-facebook" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/watthemehak/"
                      className="instagram"
                      target="_blank"
                    >
                      <i className="fa fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/mehakvohra/"
                      className="linkedin"
                      target="_blank"
                    >
                      <i className="fa fa-linkedin" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/user/watthemehak"
                      className="youtube"
                      target="_blank"
                    >
                      <i className="fa fa-youtube" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.quora.com/profile/Mehak-Vohra"
                      className="quora"
                      target="_blank"
                    >
                      <i className="fa fa-quora" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-6">
            <div className="block block--style-3 block--style-3-v2">
              <div className="block-image">
                <img src={rohan} className="block-image" />
              </div>
              <div className="block-body py-3">
                <h3 className="heading heading-6 strong-600 mb-0">
                  Rohan Thakkar
                </h3>
                <h4 className="heading heading-sm strong-300 mb-0">
                  Financial Literacy
                </h4>
              </div>
              <div className="block-body border-top py-3">
                <p className="mb-0">
                  Rohan Thakkar brings an entertaining and results oriented spin
                  to an otherwise boring topic, financial literacy. Rohan
                  leverages metaphors and emojis to make an impact and relate
                  with any audience wanting to understand and make headway with
                  millennials.
                </p>
              </div>
              <div className="block-footer border-top py-3">
                <ul className="social-media social-media--style-1-v4">
                  <li>
                    <a
                      href="https://www.facebook.com/rohant21/"
                      className="facebook"
                      target="_blank"
                      title="Facebook"
                    >
                      <i className="fa fa-facebook" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/rohant21/"
                      className="instagram"
                      target="_blank"
                    >
                      <i className="fa fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/rohanthakkar/"
                      className="linkedin"
                      target="_blank"
                    >
                      <i className="fa fa-linkedin" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-6">
            <div className="block block--style-3 block--style-3-v2">
              <div className="block-image">
                <img src={john} className="block-image" />
              </div>
              <div className="block-body py-3">
                <h3 className="heading heading-6 strong-600 mb-0">John Frye</h3>
                <h4 className="heading heading-sm strong-300 mb-0">
                  Marketing and Growth
                </h4>
              </div>
              <div className="block-body border-top py-3">
                <p className="mb-0">
                  John Frye was on ABC Family's "Startup U" where he launched
                  his first startup Granted, the AngelList for Nonprofits. He
                  now is a growth marketer for Bevy labs where he helps scale
                  the best communities in the world.
                </p>
              </div>
              <div className="block-footer border-top py-3">
                <ul className="social-media social-media--style-1-v4">
                  <li>
                    <a
                      href="https://www.facebook.com/JFryeOfficial/"
                      className="facebook"
                      target="_blank"
                      title="Facebook"
                    >
                      <i className="fa fa-facebook" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/johnfrye/"
                      className="linkedin"
                      target="_blank"
                    >
                      <i className="fa fa-linkedin" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/user/AppleTalkz"
                      className="youtube"
                      target="_blank"
                    >
                      <i className="fa fa-youtube" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="slice-lg sct-color-2 border-top border-bottom">
      <div className="container text-center">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title section-title--style-1 text-center mb-4">
              <h3 className="section-title-inner heading-2 text-normal">
                Use Our Influence! Shoot us a Note.
              </h3>
              <span className="section-title-delimiter clearfix d-none" />
            </div>

            <span className="clearfix" />

            <div className="fluid-paragraph fluid-paragraph-sm text-center">
              <p className="text-lg line-height-1_8 c-gray-light">
                If you're interested with working us, we'd love to hear from
                you.
                <br />Let's take on the business world together.
              </p>

              <a
                href="mailto:hello@jamochamedia.com"
                target="_blank"
                className="btn btn-styled btn-base-1 btn-circle mt-4"
              >
                Sign Up
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default BrewCrew;



// WEBPACK FOOTER //
// ./src/pages/brew-crew.js